export const transactionTypes = [
  {
    code: '1',
    name: 'Incoming Funds',
    language: 'en',
    description:
      'Funds recieved for use on the activity, which can be from an external or internal source. ',
  },
  {
    code: '2',
    name: 'Outgoing Commitment',
    language: 'en',
    description:
      'A firm, written obligation from a donor or provider to provide a specified amount of funds, under particular terms and conditions, for specific purposes, for the benefit of the recipient. ',
  },
  {
    code: '3',
    name: 'Disbursement',
    language: 'en',
    description:
      'Outgoing funds that are placed at the disposal of a recipient government or organisation, or funds transferred between two separately reported activities.',
  },
  {
    code: '4',
    name: 'Expenditure',
    language: 'en',
    description:
      'Outgoing funds that are spent on goods and services for the activity.',
  },
  {
    code: '5',
    name: 'Interest Payment',
    language: 'en',
    description:
      'The actual amount of interest paid on a loan or line of credit, including fees.',
  },
  {
    code: '6',
    name: 'Loan Repayment',
    language: 'en',
    description:
      'The actual amount of principal (amortisation) repaid, including any arrears. ',
  },
  {
    code: '7',
    name: 'Reimbursement',
    language: 'en',
    description:
      'A type of disbursement that covers funds that have already been spent by the recipient, as agreed in the terms of the grant or loan',
  },
  {
    code: '8',
    name: 'Purchase of Equity',
    language: 'en',
    description:
      'Outgoing funds that are used to purchase equity in a business',
  },
  {
    code: '9',
    name: 'Sale of Equity',
    language: 'en',
    description: 'Incoming funds from the sale of equity. ',
  },
  {
    code: '10',
    name: 'Credit Guarantee',
    language: 'en',
    description:
      'A commitment made by a funding organisation to underwrite a loan or line of credit entered into by a third party. ',
  },
  {
    code: '11',
    name: 'Incoming Commitment',
    language: 'en',
    description:
      'A firm, written obligation from a donor or provider to provide a specified amount of funds, under particular terms and conditions, reported by a recipient for this activity.',
  },
  {
    code: '12',
    name: 'Outgoing Pledge',
    language: 'en',
    description:
      'Indicative, non-binding advice of an intended outgoing commitment.',
  },
  {
    code: '13',
    name: 'Incoming Pledge',
    language: 'en',
    description:
      'Indicative, non-binding advice of an intended incoming commitment.',
  },
];
